import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type CreateResetFileHashes = ClientInferResponseBody<typeof contract.admin.resetFileHashes>;

export const createResetFileHashes = async (): Promise<CreateResetFileHashes> => {
  const response = await api.admin.resetFileHashes.mutation({
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to create ResetFileHashes", response.status, response.body);
};
